<div class="container">
  <div class="logo mb-2 text-center" style="margin: auto;">
    <img src="../../../assets/WhatsApp Image 2022-08-02 at 5.41.07 AM.jpeg" alt="" routerLink="/">
    <h5 class="display-5 mb-5">Book an Appointment</h5>
  </div>

  <div class="main-content">
    <div class="input-group input-group-lg mb-3">
      <input
        type="text"
        class="form-control"
        placeholder="Enter your name*"
        [(ngModel)]="bookAppointmentData.name"
        autofocus>
    </div>
    <div class="input-group input-group-lg mb-3">
      <input
        type="email"
        class="form-control"
        placeholder="Enter your email*"
        [(ngModel)]="bookAppointmentData.email">
    </div>
    <hr>
    <div class="row">
      <div class="col">
        <label>Select a service*</label>
        <div class="input-group input-group-lg mb-3">
          <select class="custom-select" [(ngModel)]="bookAppointmentData.service" autocomplete="off">
            <option selected>Select...</option>
            <option value="{{ service._id }}" *ngFor="let service of servicesList">{{ service.title }}</option>
          </select>
        </div>
      </div>
      <div class="col">
        <label>Enter amount*</label>
        <div class="input-group input-group-lg mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text">$</span>
          </div>
          <input
            type="number"
            class="form-control"
            [(ngModel)]="bookAppointmentData.amount">
        </div>
      </div>
    </div>
    <div class="alert alert-danger text-center" role="alert" *ngIf="emptyFieldError===true">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-circle" viewBox="0 0 16 16">
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
        <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>
      </svg>
      Enter values in all fields!
    </div>

    <button type="button" class="btn btn-block btn-primary" (click)="clickFunction()" *ngIf="loaderSpinner===false">
      Pay with Card
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right pb-1" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z"/>
        <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z"/>
      </svg>
    </button>

    <button type="button" class="btn btn-block btn-primary" *ngIf="loaderSpinner===true">
      <div class="loader mb-1"></div>
    </button>
    <button type="button" class="btn btn-block btn-outline-danger" routerLink="/">
      Cancel
    </button>
  </div>
  <div class="text-center mt-4" *ngIf="loaderSpinner===true">
    <small>Redirecting to Stripe checkout...</small>
  </div>
  <div class="text-center my-4">
    <small style="cursor: pointer; color: gray; text-decoration: underline;" routerLink="/">Go To Homepage</small>
  </div>
</div>
